import { render, staticRenderFns } from "./BtnZzimWithEvent.vue?vue&type=template&id=2071ed56"
import script from "./BtnZzimWithEvent.vue?vue&type=script&lang=js"
export * from "./BtnZzimWithEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports